(() => {
  if (window.kmCardRatingsInitialized) return;
  window.kmCardRatingsInitialized = true;
  let loading = false;
  let timer;
  const load = () => {
    if (loading || !document.querySelector('[data-km-sa-product]:empty')) return;
    loading = true;
    const script = document.createElement('script');
    script.src = 'https://www.shopperapproved.com/widgets/group2.0/39277.js';
    script.async = true;
    script.onload = () => { loading = false; };
    script.onerror = () => { loading = false; };
    document.head.appendChild(script);
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(load, 200); };
  // Collection filters and pagination replace cards without a full page load.
  new MutationObserver((changes) => {
    if (changes.some(change => [...change.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches('[data-km-sa-product]') || node.querySelector('[data-km-sa-product]'))
    ))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  load();
})();
